import PrimaryLink from './PrimaryLink';

export { PrimaryLink };
